import { freightRateConstants } from '../../_constants';
import { freightRateServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const freightRateActions = {
    // getAllFreightRates,
    // getFreightRates,
    createFreightRate,
    updateFreightRate,
    getFreightRateById,
    deleteFreightRates,
    activation,
    // searchFreightRates,
    getFreightRateListByCode,
    groupByChargeCode,
    readGroupCharge,
    loadChargeByChargeCodeOrigin
};


function freightRateFetching() { return { type: freightRateConstants.FREIGHT_RATE_FETCHING } }
function freightRateFetched() { return { type: freightRateConstants.FREIGHT_RATE_FETCHED } }

// function getAllFreightRates() {
//     return dispatch => {
//         freightRateServices.getAllFreightRates()
//             .then(
//                 freightRates => dispatch(success(freightRates)),
//                 error => dispatch(alertActions.error(error.toString()))
//             );
//     };
//     function success(freightRates) { return { type: freightRateConstants.GET_ALL_FREIGHT_RATES, freightRates } }
// }
// function getFreightRates(skip, take, filter, search) {
//     return dispatch => {
//         dispatch(freightRateFetching());
//         freightRateServices.getFreightRates(skip, take, filter, search)
//             .then(
//                 freightRates => {
//                     if (freightRates.length > 0) {
//                         dispatch(success(freightRates));
//                     } else {
//                         dispatch(freightRateFetched());
//                         dispatch(alertActions.warning(freightRates.message))
//                     }
//                 },
//                 error => {
//                     dispatch(freightRateFetched());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             );
//     };
//     function success(freightRates) { return { type: freightRateConstants.GET_FREIGHT_RATES, freightRates } }
// }
function createFreightRate(freightRate, userProfile) {
    return dispatch => {
        dispatch(freightRateFetching());
        dispatch(userActions.notallowLeavePage());
        freightRateServices.createFreightRate(freightRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(alertActions.success('Freight rate added successfully'))
                    window.location.href = '/master_data/freight_rate';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateFreightRate(freightRate, userProfile, charge, origin) {
    return dispatch => {
        dispatch(updateFreightRate(freightRate));
        dispatch(userActions.notallowLeavePage());
        freightRateServices.updateFreightRate(freightRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Freight rate updated successfully'))
                    window.location.href = '/master_data/freight_rate/' + charge + '/' + origin;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function updateFreightRate() { return { type: freightRateConstants.UPDATE_FREIGHT_RATE } }
}
function getFreightRateById(id) {
    return dispatch => {
        dispatch(freightRateFetching());
        dispatch(userActions.allowLeavePage());
        freightRateServices.getFreightRateById(id)
            .then(
                freightRate => {
                    dispatch(success(freightRate))
                    dispatch(freightRateFetched());
                },
                error => {
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(freightRate) { return { type: freightRateConstants.GET_FREIGHT_RATE_BY_ID, freightRate } }
}
function getFreightRateListByCode(code, destination, origin) {
    return dispatch => {
        dispatch(freightRateFetching());
        freightRateServices.getFreightRateListByCode(code, destination, origin)
            .then(
                freightRate => {
                    dispatch(success(freightRate))
                    dispatch(freightRateFetched());
                },
                error => {
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(freightRate) { return { type: freightRateConstants.GET_FREIGHT_RATE_BY_ID, freightRate } }
}
function deleteFreightRates(id, type, take, charge, origin) {
    return dispatch => {
        dispatch(freightRateFetching());
        dispatch(userActions.notallowLeavePage());
        freightRateServices.deleteFreightRates(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Freight rates deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/freight_rate/' + charge + '/' + origin;
                            break;
                        default:
                            dispatch(loadChargeByChargeCodeOrigin(charge, origin, 0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getFreightRateById(id));
                            break;
                        default:
                            dispatch(loadChargeByChargeCodeOrigin(charge, origin, 0, take));
                            break;
                    }
                }
            );
    };
}
function activation(code, destination, origin, id, isActive) {
    return dispatch => {
        dispatch(freightRateFetching());
        dispatch(userActions.notallowLeavePage());
        freightRateServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getFreightRateListByCode(code, destination, origin));
                    dispatch(alertActions.success(isActive ? 'Freight rate activated successfully' : 'Freight rate deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
// function searchFreightRates(take, filter, search) {
//     return dispatch => {
//         dispatch(freightRateFetching());
//         freightRateServices.searchFreightRates(take, filter, search)
//             .then(
//                 freightRates => dispatch(searchFreightRates(freightRates)),
//                 error => {
//                     dispatch(freightRateFetched());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             );
//     };
//     function searchFreightRates(freightRates) { return { type: freightRateConstants.SEARCH_FREIGHT_RATES, freightRates } }
// }
function groupByChargeCode() {
    return dispatch => {
        dispatch(freightRateFetching());
        freightRateServices.groupByChargeCode()
            .then(
                freightRateCharge => {
                    dispatch(success(freightRateCharge))
                    dispatch(freightRateFetched());
                },
                error => {
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(freightRateCharge) { return { type: freightRateConstants.GET_FREIGHT_RATES_CHARGE, freightRateCharge } }
}
function readGroupCharge(charge) {
    return dispatch => {
        dispatch(freightRateFetching());
        freightRateServices.readGroupCharge(charge)
            .then(
                freightRateOrigin => {
                    dispatch(success(freightRateOrigin))
                    dispatch(freightRateFetched());
                },
                error => {
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(freightRateOrigin) { return { type: freightRateConstants.GET_FREIGHT_RATES_ORIGIN, freightRateOrigin } }
}
function loadChargeByChargeCodeOrigin(charge, branchOrigin, skip, take, search) {
    return dispatch => {
        dispatch(freightRateFetching());
        freightRateServices.loadChargeByChargeCodeOrigin(charge, branchOrigin, skip, take, search)
            .then(
                freightRates => {
                    if (freightRates.length > 0) {
                        dispatch(success(freightRates))
                        dispatch(freightRateFetched());
                    } else {
                        dispatch(alertActions.warning(freightRates.message))
                        dispatch(freightRateFetched());
                    }
                },
                error => {
                    dispatch(freightRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(freightRates) { return { type: freightRateConstants.GET_FREIGHT_RATES_CHARGE_ORIGIN, freightRates } }
}